import admin from './view';

export default [
  {
    path: '/',
    redirect: 'poor',
  },
  {
    path: ':category',
    component: admin('/complaint/list'),
  },
  {
    path: ':category/:sq',
    component: admin('/complaint/detail'),
  },
  { path: '*', redirect: '/404' },
];



// WEBPACK FOOTER //
// ./src/router/admin/complaint.js